import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'

export default function useDeviceInstallationsList() {
  // Table Handlers
  const refDeviceInstallationsTable = ref(null)

  // Table columns
  const tableColumns = [
    { key: 'modemIdentifier', sortable: false, label: i18n.t('Modem Identifier') },
    { key: 'assetIdentifier', sortable: false, label: i18n.t('Asset') },
    { key: 'installationDate', sortable: false, label: i18n.t('Install Date') },
    { key: 'installationTechnician', sortable: false, label: i18n.t('Installation Technician') },
    { key: 'responsibleInstallation', sortable: false, label: i18n.t('Responsible Installation') },
    { key: 'deinstallationDate', sortable: false, label: i18n.t('Uninstall Date') },
    { key: 'deinstallationTechnician', sortable: false, label: i18n.t('Uninstall Technician') },
    { key: 'responsibleUninstallation', sortable: false, label: i18n.t('Responsible Uninstallation') },
  ]

  const perPage = ref(10)
  const totalInstallations = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')

  // Filters
  const showFilters = ref(false)
  const deviceId = ref('')
  const customerId = ref('')
  const startDate = ref('')
  const endDate = ref('')
  const searchDevice = ref('')
  const searchCustomer = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refDeviceInstallationsTable.value
      ? refDeviceInstallationsTable.value.localItems.length
      : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInstallations.value,
    }
  })

  const refetchData = () => {
    if (refDeviceInstallationsTable.value) {
      refDeviceInstallationsTable.value.refresh()
    }
  }

  // Watch apenas para paginação
  watch([currentPage, perPage], () => {
    refetchData()
  })

  const fetchInstallations = (ctx, callback) => {
    store
      .dispatch('app-device/fetchDeviceInstallations', {
        deviceId: deviceId.value,
        customerId: customerId.value,
        startDate: startDate.value,
        endDate: endDate.value,
        page: currentPage.value,
        perPage: perPage.value,
      })
      .then(response => {
        const data = response.data.data || []
        const totalCount = response.data.totalItems || response.data.totalCount || data.length
        
        totalInstallations.value = totalCount
        
        callback(data)
      })
      .catch((error) => {
        totalInstallations.value = 0
        callback([])
      })
  }

  // Clear all filters
  const clearFilters = () => {
    deviceId.value = ''
    customerId.value = ''
    startDate.value = ''
    endDate.value = ''
    searchDevice.value = ''
    searchCustomer.value = ''
    searchQuery.value = ''
  }

  // Update filters
  const updateDeviceId = (value) => {
    deviceId.value = value || ''
  }

  const updateCustomerId = (value) => {
    customerId.value = value || ''
  }

  const updateDateRange = (start, end) => {
    startDate.value = start || ''
    endDate.value = end || ''
  }

  const updateSearchDevice = (value) => {
    // Garantir que seja sempre uma string
    searchDevice.value = typeof value === 'string' ? value : String(value || '')
  }

  const updateSearchCustomer = (value) => {
    // Garantir que seja sempre uma string
    searchCustomer.value = typeof value === 'string' ? value : String(value || '')
  }

  return {
    fetchInstallations,
    tableColumns,
    perPage,
    currentPage,
    totalInstallations,
    dataMeta,
    perPageOptions,
    searchQuery,
    refDeviceInstallationsTable,
    
    // Filters
    showFilters,
    deviceId,
    customerId,
    startDate,
    endDate,
    searchDevice,
    searchCustomer,
    
    refetchData,
    clearFilters,
    updateDeviceId,
    updateCustomerId,
    updateDateRange,
    updateSearchDevice,
    updateSearchCustomer,
  }
}

